<template>
  <Loading v-if="isLoading" loadingString="Update Pin" />
  <div
    v-else
    id="mainDiv"
    class="container roundedBorder secondary-bg primary-fg"
  >
    <h2>Update Pin</h2>

    <div class="row">
      <div class="input-field col s12 m12">
        <i class="material-icons prefix secondary-fg">lock_outline</i>
        <input
          id="icon_prefix"
          class="primary-fg"
          type="text"
          v-model="enteredPreviousPin"
        />
        <label for="icon_prefix">Previous PIN</label>
      </div>

      <div class="input-field col s12 m12">
        <i class="material-icons prefix secondary-fg">lock_outline</i>
        <input
          id="icon_prefix2"
          class="primary-fg"
          type="text"
          v-model="enteredNewPin"
        />
        <label for="icon_prefix2">New PIN</label>
      </div>
      <div class="col s12 m12" style="padding-top: 20px">
        <a
          v-on:click="updatePin"
          class="waves-effect waves-light primary-bg primary-fg btn s12"
          style="width: 100%"
        >
          Update PIN
          <i class="material-icons left">loop</i>
        </a>
      </div>
    </div>

    <span class="secondary-fg">
      Update your client side encryption key (PIN).
    </span>
  </div>
</template>

<script>
import M from "materialize-css";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import Loading from "../components/Loading.vue";
import {
  SecretPasswordObject,
  PIN_INIT_API_ENDPOINT
} from "../common.js";

export default {
  name: "UpdatePin",
  components: {
    Loading
  },
  data: function() {
    return {
      enteredPreviousPin: "",
      enteredNewPin: "",
      isLoading: true
    };
  },
  methods: {
    validateCSEEnabled: async function() {
      let enabled = await this.isCSEEnabled();
      if (!enabled) {
        this.$router.push("/pin/initialize");
      }

      this.isLoading = false;
    },
    updatePin: async function() {
      if (this.enteredNewPin.length < 4) {
        alert("The new PIN should be at least 4 characters");
        return;
      }

      try {
        this.isLoading = true;
        // Check if the entered previous pin is the correct pin
        let salt = await this.fetchSalt();
        let hops = this.calculateHash(this.enteredPreviousPin, salt);
        let isCorrect = await this.validateHops(hops);

        if (isCorrect) {
          // Fetch the data to be encrypted on the client side
          let plainPasswords = await this.fetchPasswords();
          let plainNotes = await this.fetchNotes();

          let newEncryptedPasswords = [];
          let newEncryptedNotes = [];


          // Calculate the previous hohoPin
          let previousHohoPin = this.calculateHash(hops, salt);

          // Create a salt
          let newSalt = this.generateSalt();

          // Create the hash of (pin + salt)
          let newHops = this.calculateHash(this.enteredNewPin, newSalt);

          // Create the hash of hash of (pin + salt)
          let newHohoPin = this.calculateHash(newHops, newSalt);

          // Now re-encrypt all data on the client side
          for (let i = 0; i < plainPasswords.length; i++) {
            newEncryptedPasswords.push(
              new SecretPasswordObject(
                plainPasswords[i].guid,
                this.encrypt(plainPasswords[i].content, newHops),
                this.encrypt(plainPasswords[i].username, newHops),
                this.encrypt(plainPasswords[i].password, newHops),
                this.encrypt(plainPasswords[i].website, newHops),
                this.encrypt(plainPasswords[i].isFavorite, newHops),
                this.encrypt(plainPasswords[i].notes, newHops)
              )
            );
          }

          for (let i = 0; i < plainNotes.length; i++) {
            newEncryptedNotes.push({
              noteContent: this.encrypt(plainNotes[i].noteContent, newHops),
              lastEditedDate: this.encrypt(plainNotes[i].lastEditedDate, newHops),
              guid: plainNotes[i].guid,
              timeStamp: this.encrypt(plainNotes[i].timeStamp, newHops),
              isFavorite: this.encrypt(plainNotes[i].isFavorite, newHops)
            });
          }

          // Store the hohoPin and salt at the database
          // and update the data
          let idToken = await this.getIdToken();
          const options = {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: idToken
            },
            body: JSON.stringify({
              previousHohoPin: previousHohoPin,
              newSalt: newSalt,
              newHohoPin: newHohoPin,
              encryptedPasswords: newEncryptedPasswords,
              encryptedNotes: newEncryptedNotes,
            })
          };
          let serverResponse = await fetch(PIN_INIT_API_ENDPOINT, options)
            .then(res => {
              return res.json();
            })
            .catch(err => {
              alert(`Failed while updating PIN: ${err}`);
              this.isLoading = false;
              return;
            });

          if (!serverResponse.success) {
            alert(`Failed while updating PIN. ${serverResponse.data}`);
            this.isLoading = false;
            return;
          }

          // Save the hops in the local storage
          this.setHops(newHops);

          this.isLoading = false;
          alert("Successfully updated PIN");
          this.$router.push("/");
        } else {
          this.isLoading = false;
          alert("Entered previous PIN is not correct");
        }
      } catch (err) {
        this.isLoading = false;
        alert(err);
      }
    }
  },
  mounted: async function() {
    // If there is no user navigate to the root page
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
      return;
    }

    // Initialize the materialize components
    // This also closes the navbar if open
    M.AutoInit();

    await this.validateCSEEnabled();
  },
  metaInfo: {
    title: "Update Pin",
    meta: [
      {
        name: "description",
        content: "Store encypted passwords with LockerApp."
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application"
      }
    ]
  }
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}

.loading {
  background-image: url("../assets/loading.gif");
  background-size: 100%;
}
</style>
